export class NextivaService {
  public static async SetupChatClient() {
    let nextivaScript = document.createElement("script");
    nextivaScript.setAttribute("type","text/javascript");
    nextivaScript.setAttribute("src","https://portal.unityclient.com/webchat/js/webchat.js");
    nextivaScript.setAttribute("id","WebChatClient");
    nextivaScript.setAttribute("queueId","New.Dealer.Support.2608573G@nextiva.com");
    nextivaScript.setAttribute("StreamIdentifier","New.Dealer.Support.2608573G_WebChat_639062644759519886@nextiva.com");
    
    document.head.appendChild(nextivaScript);
  } 
}
